import { Box, Typography } from '@mui/material';
import typography from '../../styles/typography.module.css';
import layout from '../../styles/layout.module.css';
import { useTranslation } from 'react-i18next';
export const DriverConfiguration = ({ model, driverConfig }) => {
    const { t } = useTranslation();
    const driverConf = t(`${model}.driver_config`);
    const info =
        driverConf.localeCompare(`${model}.driver_config`) === 0 || driverConf === undefined
            ? driverConfig
            : driverConf;
    return (
        <Box className={layout.subSectionContainer} style={{ width: '100%' }}>
            <Typography>
                <span className={typography.modelDescriptionSubTitle}>
                    {t('model.driver_config')}:{' '}
                </span>
                <span className={typography.modelDescription}> {info}</span>
            </Typography>
        </Box>
    );
};
